<template>
  <div class="main-body">
    <div class="header">报警信息</div>
    <div class="out">

      <div class="search2">

        <el-button size="mini" plain type="success" icon="el-icon-document-checked" @click="batchDeal" style="margin-right: 5px;">批量处理</el-button>

        <download-excel
            class = "export-excel-wrapper"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            name = "报警记录.xls"
            style="display: inline-block;margin-right: 0px;">
          <el-button type="primary" size="mini" icon="el-icon-download" plain>导出</el-button>
        </download-excel>

        <div style="float:right">

          <el-select v-model="institutionCode" clearable placeholder="请选择机构" style="margin-right:5px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-select v-model="type" clearable placeholder="请选择报警类型" title="报警类型" style="width:150px;margin-right:5px">
            <el-option
                v-for="item in typeValue"
                :key="item[0]"
                :label="item[1]"
                :value="item[0]">
            </el-option>
          </el-select>


          <el-date-picker style="margin-right: 5px;width:220px;" title="起止时间" size="mini"
                          v-model="startEndTime" :clearable="false"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <el-button size="mini" type="primary" icon="el-icon-search" plain @click="getList(true)">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th"
                @selection-change="handleSelectionChange" border>

        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column prop="userName" label="报警人" width="100" fixed>
          <template slot-scope="scope">
            <span v-if="scope.row.userName">{{scope.row.userName}}</span>
            <span v-if="scope.row.roomInfo">{{scope.row.roomInfo}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="phone" label="报警人手机" width="140"></el-table-column>
        <el-table-column prop="urgencyContact" label="紧急联系人" width="100"></el-table-column>
        <el-table-column prop="urgencyPhone" label="联系人电话" width="140"></el-table-column>

        <el-table-column label="处理状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">未处理</span>
            <span v-if="scope.row.status==1">已处理</span>
          </template>
        </el-table-column>
        <el-table-column prop="dealMessage" label="处理结果" width="200"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" width="100"></el-table-column>
        <el-table-column prop="type" :formatter="getType" label="报警类型" width="120"></el-table-column>
        <el-table-column prop="remarks" label="备注" width="200"></el-table-column>
        <el-table-column prop="address" label="位置" width="200"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" label="报警时间" min-width="160"></el-table-column>

        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status==0" type="text" size="mini" @click="handleStatus(scope.row)">处理</el-button>
            <el-button v-if="scope.row.status==0" type="text" size="mini" @click="handleCart(scope.row)">派单</el-button>

            <el-button v-if="scope.row.orderCode != null " type="text" size="mini" @click="showInfo(scope.row)">派单详情</el-button>


            <el-button type="text" size="mini" @click="Delete(scope.row)">删除</el-button>

          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Deal ref="myDeal" v-show="showModalDeal" v-on:closeDeal="closeDeal" v-on:getList="getList"></Deal>


    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

    <WriteAdd ref="myWriteAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></WriteAdd>

    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="showModalInfo=false"></Info>


  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getGovernmentCode,getStaffCode, getToken} from "@/utils/auth";


import Deal from '../Deal';

import WriteAdd from '../WriteAdd';
import Info from "../Info";

export default {
  name: "Page",
  data(){
    return{

      tableLoading:false,

      showModal:false,

      showModalDeal:false,
      showModalEdit:false,
      showModalAdd:false,
      showModalInfo:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,


      startEndTime:[],

      typeValue:[[2,'紧急按钮'],[3,'红外探测器'],[4,'门磁传感器'],[5,'水浸传感器'],[6,'网关报警'],
        [7,'睡倍健报警'],[8,'手表报警'],[9,'燃气泄漏报警器'],[10,'烟雾探测器'],
        [11,'健康异常'],[12,'App一键求助'],[13,'一氧化碳报警器'],[14,'跌倒报警']],
      type:'',


      insType:1,
      arr_ins:[],
      institutionCode: '',


      multipleSelection:[],
      alarmRecordCodeArr:[],

      json_fields: {
        "报警人": {
          field:"userName",
          callback:value=>{
            return value+"-";
          }
        },
        "房间": {
          field:"roomInfo",
          callback:value=>{
            return value+"-";
          }
        },
        "床位": {
          field:"berthInfo",
          callback:value=>{
            return value+"-";
          }
        },
        "联系电话": "phone",
        "处理状态": {
          field:"status",
          callback:value=>{
            let title = "";
            if(value == '0'){
              title = "未处理";
            }
            if(value == '1'){
              title = "已处理";
            }
            return title;
          }
        },
        "处理结果": 'dealMessage',
        "设备名称": 'deviceName',
        "报警类型": {
          field:"type",
          callback:value=>{
            var type='其他'
            this.typeValue.forEach(val=>{
              if(val[0]==value){
                type=val[1]
              }
            })
            return type
          }
        },
        "备注": 'remarks',
        "位置": 'address',
        "报警时间": {
          field:"createTime",
          callback:value=>{
            return timefilters(value);
          }
        },

      },


    }
  },
  components:{
    Deal,WriteAdd,Info
  },
  created(){

    const end = new Date();
    const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
    this.startEndTime = [start, end];

    this.th = this.$store.state.tableHeight;

    this.getIns();

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.insType,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            //this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    handleCart:function(row){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myWriteAdd.init(row);
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    showInfo(row){
      this.showModalInfo = !this.showModalInfo;
      this.$refs.myInfo.init(row.orderCode);
    },


    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    batchDeal() {
      var list = this.multipleSelection

      if(this.multipleSelection.length < 1) {
        this.$message({type: 'warning', message: '请选择记录'});
      }
      else {
        for(var i in list) {
          list[i] = list[i].alarmRecordCode;
        }
      }

      //console.log(list);

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"AlarmRecord/EditMul",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          status:1,
          alarmRecordCodes:list,
          dealMessage:'已处理',
        }
      }).then( (response)=> {
        //console.log(response);
        //this.tableLoading=false

        if(response.data.error == 0){

          this.getList();

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        //this.tableLoading=false
        console.log(error);
      });


    },
    closeDeal(){
      this.showModalDeal = false;
    },

    handleStatus(row){
      this.showModalDeal = true;
      this.$refs.myDeal.init(row.alarmRecordCode,row.userName);
    },

    timefilter(row,index,column){
      return timefilters(column)
    },
    getType(row,index,column){
      var type='其他'
      this.typeValue.forEach(val=>{
        if(val[0]==column){
          type=val[1]
        }
      })
      return type
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {

      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"AlarmRecord/InsPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
          institutionCode:this.institutionCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,

          type:this.type==''?-1:this.type,
          startTime: timefilters(this.startEndTime[0]).substring(0,10),
          endTime: timefilters(this.startEndTime[1]).substring(0,10),

        }
      }).then( (response)=> {
        //console.log(response);
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },



    async fetchData(){

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        governmentCode: getGovernmentCode(),
        institutionCode:this.institutionCode,
        pageIndex:1,
        pageSize:99999,

        type:this.type,
        startTime: timefilters(this.startEndTime[0]).substring(0,10),
        endTime: timefilters(this.startEndTime[1]).substring(0,10),

      }

      const response = await this.$axios.post(this.$deviceUrl+"AlarmRecord/InsPage",data);
      return response.data.data.list;
    },
    startDownload:function (){
      this.showModal = true;
    },
    finishDownload:function (){
      this.showModal = false;
    },


    Delete(row) {
      this.$confirm("您确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {


        let dataForm = {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          alarmRecordCode: row.alarmRecordCode,
        };


        this.$axios({
          method: "post",
          url: this.$deviceUrl + "AlarmRecord/Delete",
          data:dataForm,
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        //this.$message({type: "info", message: "已取消解绑",});
      });
    },



  }
}
</script>

<style scoped>

.main-body{
  background-color: #f2f2f2;height: 100%;
}

.main-body .header{
  background-color: #fff;padding:0px 10px; line-height: 50px;border-bottom: 1px solid #ddd;
}

.main-body .out {
  padding: 10px;
}

.main-body .out .search{

}

.main-body .out .table {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.main-body .out .page {
  background-color: #fff;padding: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}



.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;

}
.label{
  padding: 5px 0px;
}

</style>
